(function () {
  const SOURCES = {
    CART_DRAWER: 'cart drawer',
    PRODUCT_PAGE: 'pdp',
    QUICK_ADD: 'quick add',
    BUILD_BOX: 'build box page',
    CART_POPUP: 'cart popup',
  };

  function getCartLineItemSource(contextElement) {
    const el = contextElement && contextElement.nodeType === 1 ? contextElement : document.body;

    const cartSidebar = document.getElementById('site-cart-sidebar');
    if (cartSidebar && cartSidebar.contains(el)) {
      return SOURCES.CART_DRAWER;
    }

    if (el.closest?.('cart-recommendations')) {
      return SOURCES.CART_DRAWER;
    }

    if (el.closest?.('[data-js-site-cart-popup-content]')) {
      return SOURCES.CART_POPUP;
    }

    if (el.closest?.('[data-build-box-root]')) {
      return SOURCES.BUILD_BOX;
    }

    if (el.closest?.('quick-add-to-cart, quick-buy-modal, .product-item__quick-buy')) {
      return SOURCES.QUICK_ADD;
    }

    if (
      document.body.classList.contains('template-product') &&
      (el.closest?.('[data-js-product-component]') || el.closest?.('design-box-variant-picker'))
    ) {
      return SOURCES.PRODUCT_PAGE;
    }

    if (document.body.classList.contains('template-product')) {
      return SOURCES.PRODUCT_PAGE;
    }

    if (
      document.body.classList.contains('template-index') ||
      document.body.classList.contains('template-collection') ||
      document.body.classList.contains('template-search')
    ) {
      return SOURCES.QUICK_ADD;
    }

    return SOURCES.PRODUCT_PAGE;
  }

  function appendSourceToUrlEncodedBody(body, contextElement) {
    const encodedKey = encodeURIComponent('properties[_source]');
    if (body && (body.includes(encodedKey) || body.includes('properties[_source]'))) {
      return body;
    }

    const source = getCartLineItemSource(contextElement);
    const pair = `${encodedKey}=${encodeURIComponent(source)}`;
    return body ? `${body}&${pair}` : pair;
  }

  function getCartLineItemSourceProperties(contextElement) {
    return { _source: getCartLineItemSource(contextElement) };
  }

  window.KROWN = window.KROWN || { settings: {}, functions: {} };
  KROWN.functions = KROWN.functions || {};
  KROWN.functions.getCartLineItemSource = getCartLineItemSource;
  KROWN.functions.appendCartLineItemSource = appendSourceToUrlEncodedBody;
  KROWN.functions.getCartLineItemSourceProperties = getCartLineItemSourceProperties;
  KROWN.cartLineItemSources = SOURCES;
})();
